/* Shop / Rent Mode Switcher */
(function() {
  'use strict';

  function isRentMode() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('mode') === 'rent') return true;
    try {
      if (document.referrer && new URL(document.referrer).pathname.includes('/collections/rent')) return true;
    } catch(e) {}
    return false;
  }

  var rentMode = isRentMode();

  if (rentMode) {
    document.body.classList.add('rent-mode');
  } else {
    /* BUY MODE: Remove FlexConversion config so its JS has nothing to hook into */
    /* This runs before custom-variant.js (which is deferred) */
    var fcConfig = document.getElementById('flex-conversion-config');
    var fcCart = document.getElementById('flex-conversion-cart');
    var fcBooster = document.getElementById('flex-conversion-setting-booster');
    if (fcConfig) fcConfig.remove();
    if (fcCart) fcCart.remove();
    if (fcBooster) fcBooster.remove();

    /* Also remove the entire FlexConversion app block container */
    var fcBlocks = document.querySelectorAll('[id*="flexcon_product_rental_hire"]');
    fcBlocks.forEach(function(el) { el.remove(); });
  }

  /* Rewrite product links on rent collection page */
  if (window.location.pathname === '/collections/rent') {
    function rewriteLinks() {
      var links = document.querySelectorAll('a[href*="/products/"]');
      links.forEach(function(link) {
        var href = link.getAttribute('href');
        if (href && !href.includes('mode=rent')) {
          var separator = href.includes('?') ? '&' : '?';
          link.setAttribute('href', href + separator + 'mode=rent');
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rewriteLinks);
    } else {
      rewriteLinks();
    }
    new MutationObserver(rewriteLinks).observe(document.body, { childList: true, subtree: true });
  }
})();
